import {
  AccessibilityPlugin,
  ScreenReaderEnabledResult,
  AccessibilitySpeakOptions,
  ScreenReaderStateChangeCallback,
  PluginListenerHandle,
} from '@absis/core-plugins';
const CBAccessibility: AccessibilityPlugin = {
  isScreenReaderEnabled: async (): Promise<ScreenReaderEnabledResult> => {
    return Promise.resolve({ value: false });
  },
  speak: async (options: AccessibilitySpeakOptions): Promise<void> => {
    if (!('speechSynthesis' in window)) {
      return Promise.reject(
        'Browser does not support the Speech Synthesis API'
      );
    }
    const utterance = new SpeechSynthesisUtterance(options.value);
    if (options.language) {
      utterance.lang = options.language;
    }
    window.speechSynthesis.speak(utterance);
    return Promise.resolve();
  },
  addListener: (
    eventName: 'accessibilityScreenReaderStateChange',
    listenerFunc: ScreenReaderStateChangeCallback
  ): PluginListenerHandle => {
    eventName && listenerFunc({ value: false });
    return { remove: () => 'removed' };
  },
  removeAllListeners: (): void => undefined,
};

export { CBAccessibility };
